import React from "react";

import { MenuCardSkeleton } from "components/Shared/Skeletons";

export const DeliveryProductLoadingSkeleton = () => {
  return <MenuCardSkeleton className="elevation-low rounded" />;
};

export default DeliveryProductLoadingSkeleton;
